module.exports = __webpack_public_path__ + "static/img/03_05_echorex.8bbd6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_05_echorex.png
// module id = SniY
// module chunks = 12